// extracted by mini-css-extract-plugin
module.exports = {"barLabel":"task-list_barLabel__1vqnm","barLabelOutside":"task-list_barLabelOutside__27TF7"};